import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class AcademizerCommand extends RequestData<string[] | undefined> {
  constructor(public readonly text: string) {
    super()
  }
}

export const academizer = (text: string) =>
  mediator.send<string[] | undefined>(new AcademizerCommand(text))
